<template>
  <div class="infor" ref="infor">
    <!-- 业主信息 -->
    <section>
      <el-form :model="formInline" :inline="true" ref="form">
        <el-form-item label="业主名称" prop="unitName">
          <el-input
            v-model="formInline.unitName"
            placeholder="输入业主名称"
            style="width: 150px"
            clearable=""
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="行业类型" prop="industry">
          <el-input
            v-model="formInline.industry"
            placeholder="输入行业类型"
            style="width: 150px"
            clearable=""
          ></el-input>
        </el-form-item> -->
        <el-form-item label="类型" prop="label">
          <el-select
            v-model="formInline.label"
            placeholder="请选择类型"
            clearable=""
          >
            <el-option
              v-for="(item, index) in checkStatus"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">搜索</el-button>
          <el-button @click="clearForm">清空</el-button>
          <!-- {{ role }} -->
        </el-form-item>
        <el-row style="float: right; margin-right: 20px">
          <el-button
            type="primary"
            @click="addClick"
            v-hasPermi="['apartment:owner:add']"
            >新增业主</el-button
          >
          <el-button
          @click="exportData" type="warning"
            >导出</el-button
          >
        </el-row>
        <div>{{ sum }}</div>
      </el-form>
    </section>
    <div class="background">
      <div class="showView">
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="切换视图"
          placement="bottom"
        >
          <i class="el-icon-refresh" @click="showView = !showView"></i>
        </el-tooltip> -->
        <el-button type="primary" icon="el-icon-refresh" @click="showView = !showView">{{ showView ? '列表模式' : '房图模式' }}</el-button>
      </div>

      <el-row v-show="showView" :gutter="20">
        <el-col :span="6" v-for="item in tableData">
          <OwnerManagementCard
            class="ownerCard"
            @click.native="checkDetail(item)"
            :ownerItem="item"
            v-if="roleId == 10 || roleId == 2"
          ></OwnerManagementCard>
          <OwnerManagementCard v-else class="ownerCard" :ownerItem="item">
          </OwnerManagementCard>
        </el-col>
      </el-row>
      <div v-show="!showView" class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="unitName" label="业主名称" align="center">
          </el-table-column>
          <el-table-column prop="label" label="类型" align="center">
          </el-table-column>
          <el-table-column prop="chargePersonName" label="联系人" align="center">
          </el-table-column>
          <el-table-column prop="chargePersonPhone" label="联系电话" align="center">
          </el-table-column>
          <el-table-column prop="roomNum" label="房屋数量" align="center">
          </el-table-column>
          <el-table-column prop="roomNum" label="入住人数" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" @click="goRc(row.abbreviation)">
                人才
              </el-button>
              <el-button type="text" @click="goHt(row.abbreviation)">
                合同
              </el-button>
              <el-button type="text" @click="checkDetail(row)">
                修改
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteOwnerManagement(row.id)"
                v-hasPermi="['apartment:owner:remove']"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        :page-size="pageSize"
        layout="total, prev, pager, next,sizes"
        @current-change="handleCurrentChange"
        :total="totalNum"
        @size-change="handleSizeChange"
        :current-page="currentPage"
      />
    </div>

    <addOwnerManagement
      :dialogVisible="dialogVisible"
      :title="title"
      @changeVisible="changeVisible"
      :formDataDetail="formData"
    ></addOwnerManagement>
  </div>
</template>

<script>
import addOwnerManagement from './component/addOwnerManagement.vue'
import OwnerManagementCard from './component/OwnerManagementCard.vue'
import store from '@/store'

export default {
  data() {
    return {
      formInline: {
        unitName: null,
        label: null,
      },
      pageSize: 10, //
      currentPage: 1, //当前页号
      totalNum: 0, //总页数
      title: '',
      dialogVisible: false,
      tableData: [],
      formData: {},
      showView: true,
      sum: "",
      // 所有标签
      checkStatus: [
        {
          label: '高校',
          value: 2,
        },
        {
          label: '省属企业',
          value: 3,
        },
        {
          label: '科研院',
          value: 4,
        },
        {
          label: '其他',
          value: 5,
        },
      ],
      tableData: [],
      roleId: sessionStorage.getItem('roleId'),
    }
  },
  components: {
    addOwnerManagement,
    OwnerManagementCard,
  },
  mounted() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.$http
        .post('/api/ownerManage/queryOwnerManage', {
          ...this.formInline,
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        })
        .then((res) => {
          // res.data.data.items.forEach((element) => {
          // 	if (element.showPath) {
          // 		element.showPath =
          // 			"https://images.jsitc.net.cn/repair/preview" +
          // 			element.showPath.split("/preview")[1];
          // 	}
          // });
          this.tableData = res.data.data.items
          this.totalNum = res.data.data.totalNum
          this.sum = res.data.data.sum
          //this.$message.success(res.data.message);
        })
    },
    // 新增
    addClick() {
      this.dialogVisible = true
      this.title = '新增业主'
    },
    // 编辑业主
    checkDetail(item) {
      console.log(item)
      this.dialogVisible = true
      this.title = '编辑业主'
      this.formData = {
        ...item,
      }
    },
    // 删除业主
    deleteOwnerManagement(id) {
      this.$confirm('确定删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(2222222222, id)
          // 子组件里面调用父组件的方法通过this.$parent
          // this.$parent.
           this.$http
             .post('/api/ownerManage/deleteOwnerManage', {
               deptIds: [id],
             })
             .then((res) => {
                 this.$message.success(res.data.message)
               this.getAll()
             })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 合同
    goHt(value) {
      this.$router.push({
        path: 'constractInformation',
        query: {
          name: value,
        },
      })
    },
    // 人才
    goRc(value) {
      this.$router.push({
        path: 'personnelInformation',
        query: {
          name: value,
        },
      })
    },
    // 搜素
    handleQuery() {
      this.getAll()
    },
    // 导出
    exportData() {
      this.$http.post(`/api/export/exportOwnerManage`, {
        ...this.formInline,
        pageSize: this.pageSize,
          currentPage: this.currentPage,
				}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "业主信息.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
    },
    // 清空表单
    clearForm() {
      this.$refs.form.resetFields()
      this.getAll()
    },

    // 子组件向父组件传值
    changeVisible(e) {
      this.dialogVisible = e.dialogVisible
      this.getAll()
    },
    // 分页
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getAll()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getAll()
    },
  },
}
</script>

<style scoped="scoped">
.infor {
  /* padding: 0 20px; */
}

section {
  margin-top: 20px;
}

.ownerCard {
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.ownerCard:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 4px 15px 0 rgba(0, 0, 0, 0.2);
  opacity: 0.9;
  /* 	border-radius: 10px; */
  /*透明度*/
}

.background {
  background-color: #f5f6fa;
  padding: 10px 25px;
}
.showView {
  display: flex;
  justify-content: end;
  cursor: pointer;
}
.table {
  margin-top: 15px;
}
</style>
